import { useAuthStore } from '../../../stores/authStore';
import { useAISettings } from '../../../hooks/useAISettings';
import { AISettingsSection } from '../../../components/settings/AISettingsSection';
import { SettingsSubPage } from '../components/SettingsSubPage';

export function AIFeaturesPage() {
  const user = useAuthStore(s => s.user);
  const authBusiness = useAuthStore(s => s.business);
  const { settings, usage, loading, updateToggle } = useAISettings(authBusiness?.id);

  return (
    <SettingsSubPage title="AI features" description="Receipt scanning, smart replies, summaries">
      <AISettingsSection
        settings={settings}
        usage={usage}
        loading={loading}
        onToggle={(field, value) => { if (user) updateToggle(field, value, user.id); }}
      />
    </SettingsSubPage>
  );
}
